import { ReactNode } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n, { defaultNamespace } from '../utils/i18n'

export function TileWrapper({ children }: { children: ReactNode }) {
  return (
    <div className="fds-app cxc-layout">
      <main className="cxc-container cxc-layout__main">
        <I18nextProvider i18n={i18n} defaultNS={defaultNamespace}>
          {children}
        </I18nextProvider>
      </main>
    </div>
  )
}
